import { render } from "./RegistrationFieldWork.vue?vue&type=template&id=e7c0e56a&scoped=true&ts=true"
import script from "./RegistrationFieldWork.vue?vue&type=script&lang=ts"
export * from "./RegistrationFieldWork.vue?vue&type=script&lang=ts"

import "./RegistrationFieldWork.vue?vue&type=style&index=0&id=e7c0e56a&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7c0e56a"]])

export default __exports__